import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { AlertService } from '../../exa/_services/alert.service';
import { AuthenticationService } from '../../_services/authentication.service';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PasswordValidators } from '../../exa/_validators/password.validators';
import { ComponentBase } from '../component-base.component';
import { Utils } from '../../utils';
import { Location } from '@angular/common';
import { AppProperties } from '../../app-properties';


enum Steps {
  Richiesta = 1,
  Successo = 2
}

@Component({
  selector: 'app-cambio-password',
  templateUrl: './cambio-password.component.html',
  styleUrls: ['./cambio-password.component.css']
})
export class CambioPasswordComponent extends ComponentBase {
  stato = Steps.Richiesta;

  redirecting: boolean;
  consensoRequired: boolean = false;
  primoAccesso: boolean = false;
  pwdChangeRequired: boolean = false;

  returnUrl: string;
  username: string;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    private authenticationService: AuthenticationService,
    private passwordValidator: PasswordValidators
  ) {
    super(route, router, location);

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  restartCmp() {
    this.exaForm.reset({
      oldPassword: '',
      newPassword: '',
      newPasswordAgain: ''
    });

    this.stato = Steps.Richiesta;
  }

  getMinLength() {
    return AppProperties.PASSWORD_MINLENGTH;
  }

  createForm() {
    this.exaForm = new FormGroup({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', [Validators.required, this.passwordValidator.validateNewPassword(AppProperties.PASSWORD_MINLENGTH), this.passwordValidator.validatePasswordStrength()]),
      newPasswordAgain: new FormControl('', Validators.required)
    }, this.passwordValidator.validatePasswords());

    let uctx = Utils.getUserContext();
    /*
        if (uctx.pwdChangeRequired && uctx.consensoRequired) {
          this.consensoRequired = true;
          this.exaForm.addControl('flgConsenso', new FormControl(false, this.checkboxValidator.validateTrue()))
        }
        */
    this.redirecting = uctx.pwdChangeRequired;
    //this.primoAccesso= uctx.primoAccesso;
    this.pwdChangeRequired = uctx.pwdChangeRequired;

  }

  onInit(): void {
    this.username = Utils.getUserContext().nomeUtente;
    this.createForm();
  }

  submit() {
    this.cambioPassword();
  }

  cambioPassword() {
    this.alertService.clear();

    //verifica old password
    let localSecurityToken = btoa(this.username + ":" + this.exaForm.get('oldPassword').value);
    if(localSecurityToken != Utils.getUserContext().securityToken)
    {
      this.alertService.error("I dati inseriti non sono corretti");
      return;
    }

    let newPassword = this.exaForm.get('newPassword').value;

    this.stato = Steps.Richiesta;
    this.isSaving = true;
    this.authenticationService.changePassword(newPassword).subscribe(
      data => {
        this.stato = Steps.Successo;
        let uctx = Utils.getUserContext();

        if (this.username != '') {
          // Rieffettuo il login
          this.authenticationService.logout();

          this.authenticationService.login(this.username, newPassword).subscribe(
            data => {

              setTimeout(() => {
                this.router.navigate([this.getHomepageRoute()]);
              }, 2000);
            },
            err => {
              if (err instanceof HttpErrorResponse) {
                this.showError(err);
              }
              else {
                this.alertService.error('Errore inaspettato');
                console.error(err);
              }
            }
          );
        }
      },
      err => {
        if (err instanceof HttpErrorResponse) {
          this.showError(err);
        }
        else {
          this.alertService.error('Errore inaspettato');
          console.error(err);
        }
        this.isSaving = false;
      }
    );

  }

  getSubPathLength(): number {
    return 1;
  }

  showError(err: HttpErrorResponse) {
    switch (err.status) {
      case 400: //BAD_REQUEST
        this.alertService.error("I dati inseriti non sono corretti");
        break;
      case 401:
        this.alertService.error("I dati inseriti non sono corretti");
        break;
      case 403: // FORBIDDEN
        this.alertService.error('Account temporaneamente bloccato, riprovare più tardi');
        break;
      case 500:
        this.alertService.error("Internal server error");
        break;
      default:
        this.alertService.error("Errore di rete");
        console.error(err);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cambio-password/cambio-password.component.ts